export default {
  name: 'MenuItemOptionItemsViewer',
  props: {
    optionIndex: {
      required: true,
      type: Number,
    },
    optionItems: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  beforeDestroy() {
    this.items = [];
  },
  created() {
    this.items = this.optionItems;
  },
  computed: {
    hasMultipleItems() {
      return this.items?.length > 1;
    },
  },
};
